'use client';

import { useState } from 'react';
import { AblyProvider as AblyReactProvider } from 'ably/react';
import { Loader2 } from 'lucide-react';
import dynamic from 'next/dynamic';

import AblyClient from '@/lib/api/ably';

import HeaderDashboardSkeleton from './layouts/header-dashboard-skeleton';

export default dynamic(() => Promise.resolve(AblyProvider), {
  ssr: false,
  loading: () => (
    <>
      <HeaderDashboardSkeleton />
      <div className='flex h-[calc(100vh-var(--dashboard-navbar-height-mobile))] w-full items-center justify-center md:h-[calc(100vh-var(--dashboard-navbar-height))]'>
        <Loader2 className='size-10 animate-spin text-brand-green' />
      </div>
    </>
  ),
});

type AblyProviderProps = {
  children: React.ReactNode;
};

function AblyProvider({ children }: AblyProviderProps) {
  const [ablyClient] = useState(() => AblyClient.getInstance());

  if (!ablyClient) {
    return (
      <>
        <HeaderDashboardSkeleton />
        <div className='flex h-[calc(100vh-var(--dashboard-navbar-height-mobile))] w-full items-center justify-center md:h-[calc(100vh-var(--dashboard-navbar-height))]'>
          <Loader2 className='size-10 animate-spin text-brand-green' />
        </div>
      </>
    );
  }

  return <AblyReactProvider client={ablyClient}>{children}</AblyReactProvider>;
}
